import { comparer } from 'mobx';
import { useContext, useEffect, useState } from 'react';
import * as React from 'react';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { SearchCriteriaContext } from 'stores/contexts';

import { Targeting, TargetingEvent } from './types';

const UNSET_REGION_ID = '';
const STARTING_REGION_ID = null;
const STARTING_CRITERIA = new SearchCriteriaModel().toJSON();

export const MesoTargeting: React.FunctionComponent = () => {
  const searchCriteria: SearchCriteriaModel = useContext(SearchCriteriaContext);

  if (!(window && searchCriteria)) {
    return null;
  }

  window.meso = window.meso || {};
  window.meso.targeting = window.meso.targeting || [];

  const [prevCriteria, setPrevCriteria] = useState(STARTING_CRITERIA);
  const [prevRegionId, setPrevRegionId] = useState(STARTING_REGION_ID);

  const updatedRegionId = (regionId: string) =>
    prevRegionId !== regionId && regionId !== undefined && regionId !== null && String(regionId).trim().length > 0;

  const createTargetingEvent = (regionId: string, defaultTargeting: Targeting) => {
    const updatedTargeting: TargetingEvent = { targeting: defaultTargeting };

    // require adinfo on first call
    if (prevRegionId === STARTING_REGION_ID) {
      updatedTargeting.adinfo = {};

      setPrevRegionId(UNSET_REGION_ID);
    }

    // Adding adinfo into updated targeting event will spawn a new request
    // to uciservice to obtain a correctly formatted dest targeting value.
    // Only need to make a new call to adinfo if regionId has changed.
    if (updatedRegionId(regionId)) {
      updatedTargeting.adinfo = { dest: regionId };

      setPrevRegionId(regionId);
    }

    return updatedTargeting;
  };

  useEffect(() => {
    const criteriaJSON = searchCriteria.toJSON();

    if (
      prevCriteria.endDate === criteriaJSON.endDate &&
      prevCriteria.regionId === criteriaJSON.regionId &&
      prevCriteria.star === criteriaJSON.star &&
      prevCriteria.startDate === criteriaJSON.startDate &&
      comparer.structural(prevCriteria.amenities, criteriaJSON.amenities) &&
      comparer.structural(prevCriteria.lodging, criteriaJSON.lodging) &&
      comparer.structural(prevCriteria.rooms, criteriaJSON.rooms) &&
      comparer.structural(prevCriteria.travelerType, criteriaJSON.travelerType)
    ) {
      return;
    } else {
      setPrevCriteria(criteriaJSON);
    }

    const { regionId, startDate, endDate, adults, children, star, travelerType, amenities, lodging } = searchCriteria;

    const targetingEvent = createTargetingEvent(regionId, {
      ete: endDate,
      ets: startDate,
      ha: amenities !== undefined ? amenities.toString() : '',
      hpt: lodging !== undefined ? lodging.toString() : '',
      numadults: adults,
      numchildren: children,
      sr: star,
      tt: travelerType !== undefined ? travelerType.toString() : ''
    });

    window.meso.targeting.push(targetingEvent);
  });

  return null;
};
